/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import { Scope } from "informed";
//import moment from "moment-timezone";
import Collection from "./Collection";
import Group from "./Group";
import * as constants from "../../../../../constants";
import {
	BrushfireAttendeeDataMapper,
	BrushfirePicker,
	BrushfireSessionMapper,
	CheckBox,
	ColorPicker,
	DateTimePicker,
	FileInput,
	FormstackFormPicker,
	OAuthPicker,
	IconPicker,
	MultilineTextInput,
	PageOrUrlPicker,
	PagePicker,
	PostTagPicker,
	SelectInput,
	SessionPicker,
	SessionTagPicker,
	TextAndValueArray,
	TextArray,
	TextEditor,
	TextInput,
	TimezonePicker,
	TopicPicker,
	TopicsPicker,
} from "../../../../shared/Forms";

class ModuleFields extends Component {
	getInitialValue = (collectionPrefix, property, propertyKey, defaultValue) => {
		const val = this.props.formApi.getValue(`${collectionPrefix}.${propertyKey}`);
		if (!val && val !== false) {
			return property.initialValue ? property.initialValue : defaultValue;
		}
		return val;
	};

	renderTextField(property, propertyKey, index, collectionPrefix) {
		return (
			<TextInput
				helperText={property.helperText}
				key={index}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				validationRegex={property.validationRegex ? property.validationRegex : undefined}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderCheckBox(property, propertyKey, index, collectionPrefix) {
		return (
			<CheckBox
				helperText={property.helperText}
				key={index}
				field={propertyKey}
				id={propertyKey}
				label={property.label}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, false)}
			/>
		);
	}

	renderSelect(property, propertyKey, index, collectionPrefix) {
		let values = [];
		property.values.forEach(value => {
			values.push({ key: value.value, value: value.value, label: value.text });
		});
		return (
			<SelectInput
				helperText={property.helperText}
				key={index}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				values={values}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderCollection(property, propertyKey, index, collectionPrefix) {
		return (
			<Collection
				key={index}
				property={property}
				propertyKey={propertyKey}
				renderProperties={this.renderProperties}
				formApi={this.props.formApi}
				collectionPrefix={collectionPrefix}
				initialValue={[]}
			/>
		);
	}

	renderGroup(property, propertyKey, index, collectionPrefix) {
		return (
			<Group
				key={index}
				property={property}
				propertyKey={propertyKey}
				renderProperties={this.renderProperties}
				formApi={this.props.formApi}
				collectionPrefix={collectionPrefix}
				initialValue={[]}
			/>
		);
	}

	renderMultilineTextInput(property, propertyKey, index, collectionPrefix) {
		return (
			<MultilineTextInput
				helperText={property.helperText}
				key={index}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderTextEditor(property, propertyKey, index, collectionPrefix) {
		return (
			<TextEditor
				helperText={property.helperText}
				key={index}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderVideoUrl(property, propertyKey, index, collectionPrefix) {
		return (
			<TextInput
				helperText={property.helperText}
				key={index}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				validationRegex={property.validationRegex ? property.validationRegex : undefined} //TODO add constant regex
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderAudioUrl(property, propertyKey, index, collectionPrefix) {
		return (
			<TextInput
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
				validationRegex={property.validationRegex ? property.validationRegex : undefined} //TODO add constant regex
			/>
		);
	}

	renderUrlEditor(property, propertyKey, index, collectionPrefix) {
		return (
			<TextInput
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				autocomplete="off"
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
				validationRegex={property.validationRegex ? property.validationRegex : constants.URL}
			/>
		);
	}

	renderFileInput(property, propertyKey, index, collectionPrefix) {
		return (
			<FileInput
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				appKey={this.props.appKey}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, null)}
			/>
		);
	}

	renderColorPicker(property, propertyKey, index, collectionPrefix) {
		const themeId = this.props.formApi.getValue("themeId");
		return (
			<ColorPicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				appKey={this.props.appKey}
				themeId={themeId}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, null)}
			/>
		);
	}

	renderPostTagPicker(property, propertyKey, index, collectionPrefix) {
		return (
			<PostTagPicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				appKey={this.props.appKey}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderDateTimePicker(property, propertyKey, index, collectionPrefix) {
		//const dateString = new Date(moment.utc().minutes(0).seconds(0).milliseconds(0).add(1, "hour").toISOString()).toUTCString();
		return (
			<DateTimePicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				appKey={this.props.appKey}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, null)}
			/>
		);
	}

	renderTextArray(property, propertyKey, index, collectionPrefix) {
		return (
			<TextArray
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}
	renderTextAndValueArray(property, propertyKey, index, collectionPrefix) {
		return (
			<TextAndValueArray
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderTopicPicker(property, propertyKey, index, collectionPrefix) {
		return (
			<TopicPicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				tagInstructions={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderTopicsPicker(property, propertyKey, index, collectionPrefix) {
		return (
			<TopicsPicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				tagInstructions={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderSessionPicker(property, propertyKey, index, collectionPrefix) {
		return (
			<SessionPicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				tagInstructions={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderSessionTagPicker(property, propertyKey, index, collectionPrefix) {
		return (
			<SessionTagPicker
				key={index}
				field={propertyKey}
				id={propertyKey}
				helperText={property.helperText}
				placeholder={property.label}
				tagInstructions={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderTimezonePicker(property, propertyKey, index, collectionPrefix) {
		return (
			<TimezonePicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderPagePicker(property, propertyKey, index, collectionPrefix) {
		return (
			<PagePicker
				key={index}
				helperText={property.helperText}
				field={propertyKey}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, "")}
			/>
		);
	}

	renderPageOrUrlPicker(property, propertyKey, index, collectionPrefix) {
		return (
			<PageOrUrlPicker
				key={index}
				field={propertyKey}
				helperText={property.helperText}
				id={propertyKey}
				placeholder={property.label}
				isRequired={property.isRequired}
				collectionPrefix={collectionPrefix}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, {})}
			/>
		);
	}

	renderBrushfirePicker(property, propertyKey, index, collectionPrefix) {
		let { formApi } = this.props;
		return (
			<BrushfirePicker
				propertyKey={propertyKey}
				field={`${collectionPrefix}.${propertyKey}`}
				helperText={property.helperText}
				id={`${collectionPrefix}.${propertyKey}`}
				placeholder={property.label}
				isRequired={property.isRequired}
				formApi={formApi}
				formValues={formApi.getState().values.properties}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderBrushfireSessionMapper(property, propertyKey, index, collectionPrefix) {
		let { formApi } = this.props;
		return (
			<BrushfireSessionMapper
				propertyKey={propertyKey}
				field={`${collectionPrefix}.${propertyKey}`}
				id={`${collectionPrefix}.${propertyKey}`}
				placeholder={property.label}
				isRequired={property.isRequired}
				formApi={formApi}
				formValues={formApi.getState().values.properties}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderFormstackFormPicker(property, propertyKey, index, collectionPrefix) {
		const { formApi } = this.props;
		return (
			<FormstackFormPicker
				propertyKey={propertyKey}
				field={`${collectionPrefix}.${propertyKey}`}
				id={`${collectionPrefix}.${propertyKey}`}
				isRequired={property.isRequired}
				formApi={formApi}
				formValues={formApi.getState().values.properties}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderOAuthPicker(property, propertyKey, index, collectionPrefix) {
		const { formApi } = this.props;
		return (
			<OAuthPicker
				propertyKey={propertyKey}
				field={`${collectionPrefix}.${propertyKey}`}
				id={`${collectionPrefix}.${propertyKey}`}
				integrationTypes={property.integrationTypes}
				isRequired={property.isRequired}
				formApi={formApi}
				formValues={formApi.getState().values.properties}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	renderIconPicker(property, propertyKey, index, collectionPrefix) {
		let { formApi } = this.props;
		return (
			<IconPicker
				propertyKey={propertyKey}
				field={`${collectionPrefix}.${propertyKey}`}
				id={`${collectionPrefix}.${propertyKey}`}
				placeholder={property.label}
				isRequired={property.isRequired}
				formValues={formApi.getState().values.properties}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, {})}
			/>
		);
	}

	renderComment(property, propertyKey, index, collectionPrefix) {
		return (
			<div
				className={`alert alert-info ta-left`}
				style={{ marginTop: "-15px", marginBottom: "30px" }}
				dangerouslySetInnerHTML={{ __html: property.label }}
			></div>
		);
	}

	renderBrushfireAttendeeDataMapper(property, propertyKey, index, collectionPrefix) {
		let { formApi } = this.props;
		return (
			<BrushfireAttendeeDataMapper
				propertyKey={propertyKey}
				field={`${collectionPrefix}.${propertyKey}`}
				id={`${collectionPrefix}.${propertyKey}`}
				placeholder={property.label}
				isRequired={property.isRequired}
				formApi={formApi}
				formValues={formApi.getState().values.properties}
				initialValue={this.getInitialValue(collectionPrefix, property, propertyKey, [])}
			/>
		);
	}

	undefinedInputEditor(property, propertyKey, index) {
		return <div key={index}>{property.type}</div>;
	}

	renderProperties = (properties, collectionPrefix) => {
		const propertiesKeys = Object.keys(properties);

		const fields = propertiesKeys.map((propertyKey, index) => {
			const property = properties[propertyKey];
			const { dependencyKey, dependencyValue } = property;
			let show = true;
			if (dependencyKey && dependencyKey !== "") {
				const val = !!this.props.formApi.getValue(`${collectionPrefix}.${dependencyKey}`)
					? this.props.formApi.getValue(`${collectionPrefix}.${dependencyKey}`)
					: this.props.formApi.getValue(`properties.${dependencyKey}`);
				if (Array.isArray(dependencyValue)) {
					show = dependencyValue.includes(val);
				} else if (!val || val.toString() !== dependencyValue.toString()) {
					show = false;
				}
			}
			if (show) {
				return (
					<div className={`field-hider${show ? "" : " on"}`} key={index}>
						{this.renderItem(property, propertyKey, index, collectionPrefix)}
					</div>
				);
			} else {
				return null;
			}
		});
		return fields;
	};

	renderItem = (property, propertyKey, index, collectionPrefix) => {
		switch (property.type.toLowerCase()) {
			case "text":
				return this.renderTextField(property, propertyKey, index, collectionPrefix);
			case "checkbox":
				return this.renderCheckBox(property, propertyKey, index, collectionPrefix);
			case "select":
				return this.renderSelect(property, propertyKey, index, collectionPrefix);
			case "collection":
				return this.renderCollection(property, propertyKey, index, collectionPrefix);
			case "group":
				return this.renderGroup(property, propertyKey, index, collectionPrefix);
			case "multilinetext":
				return this.renderMultilineTextInput(property, propertyKey, index, collectionPrefix);
			case "html":
				return this.renderTextEditor(property, propertyKey, index, collectionPrefix);
			case "url":
				return this.renderUrlEditor(property, propertyKey, index, collectionPrefix);
			case "mediaimage":
				return this.renderFileInput(property, propertyKey, index, collectionPrefix);
			case "colorpicker":
				return this.renderColorPicker(property, propertyKey, index, collectionPrefix);
			case "posttagpicker":
				return this.renderPostTagPicker(property, propertyKey, index, collectionPrefix);
			case "datetime":
				return this.renderDateTimePicker(property, propertyKey, index, collectionPrefix);
			case "audiourl":
				return this.renderAudioUrl(property, propertyKey, index, collectionPrefix);
			case "videourl":
				return this.renderVideoUrl(property, propertyKey, index, collectionPrefix);
			case "textarray":
				return this.renderTextArray(property, propertyKey, index, collectionPrefix);
			case "textandvaluearray":
				return this.renderTextAndValueArray(property, propertyKey, index, collectionPrefix);
			case "topicpicker":
				return this.renderTopicPicker(property, propertyKey, index, collectionPrefix);
			case "topicspicker":
				return this.renderTopicsPicker(property, propertyKey, index, collectionPrefix);
			case "sessionpicker":
				return this.renderSessionPicker(property, propertyKey, index, collectionPrefix);
			case "sessiontagpicker":
				return this.renderSessionTagPicker(property, propertyKey, index, collectionPrefix);
			case "timezonepicker":
				return this.renderTimezonePicker(property, propertyKey, index, collectionPrefix);
			case "brushfirefieldpicker":
				return this.renderBrushfirePicker(property, propertyKey, index, collectionPrefix);
			case "brushfiresessionmapper":
				return this.renderBrushfireSessionMapper(property, propertyKey, index, collectionPrefix);
			case "formstackformpicker":
				return this.renderFormstackFormPicker(property, propertyKey, index, collectionPrefix);
			case "oauthpicker":
				return this.renderOAuthPicker(property, propertyKey, index, collectionPrefix);
			case "pagepicker":
				return this.renderPagePicker(property, propertyKey, index, collectionPrefix);
			case "pageorurlpicker":
				return this.renderPageOrUrlPicker(property, propertyKey, index, collectionPrefix);
			case "iconpicker":
				return this.renderIconPicker(property, propertyKey, index, collectionPrefix);
			case "comment":
				return this.renderComment(property, propertyKey, index, collectionPrefix);
			case "brushfireattendeedatamapper":
				console.log("brushfireattendeedatamapper");
				return this.renderBrushfireAttendeeDataMapper(property, propertyKey, index, collectionPrefix);
			default:
				return this.undefinedInputEditor(property, propertyKey, index, collectionPrefix);
		}
	};

	render() {
		const { modules, moduleId } = this.props;
		const moduleToRender = modules.find(module => module.id === moduleId);

		return <Scope scope="properties">{this.renderProperties(moduleToRender.properties, "properties")}</Scope>;
	}
}

ModuleFields.propTypes = {
	appKey: PropTypes.string,
	errors: PropTypes.object,
	formApi: PropTypes.any,
	initialValues: PropTypes.object,
	moduleId: PropTypes.string,
	modules: PropTypes.array,
	values: PropTypes.object,
};

export default ModuleFields;
